import { apiSlice } from "./apiSlice";
import {
  ListResourceSessionsParams,
  PaginatedResourceSessionsResponse,
} from "../../services/resourceSessions/resourceSessions.types";

/**
 * Admin-only: partidas de juegos, videos y lecturas terminadas, para Sesiones
 * (SCRUM-1167). The whole filter+page arg is the cache key, so a slow response
 * for old filters can't race over a newer one.
 */
export const resourceSessionsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    listResourceSessions: builder.query<
      PaginatedResourceSessionsResponse,
      ListResourceSessionsParams
    >({
      query: (params) => ({
        url: "/resource-sessions/admin",
        method: "GET",
        params: {
          type: params.type,
          ...(params.level && { level: params.level }),
          ...(params.userSearch && { userSearch: params.userSearch }),
          ...(params.classroomId !== undefined && {
            classroomId: params.classroomId,
          }),
          ...(params.resourceId !== undefined && {
            resourceId: params.resourceId,
          }),
          ...(params.from && { from: params.from }),
          ...(params.to && { to: params.to }),
          ...(params.page !== undefined && { page: params.page }),
          ...(params.pageSize !== undefined && { pageSize: params.pageSize }),
        },
      }),
    }),
  }),
});

export const { useListResourceSessionsQuery } = resourceSessionsApi;
